import styled from 'styled-components'
import Menu from './Menu'
import Footer from './Footer'
import Heading from './Heading'

const PageContainerStyled = styled.div`
  background: rgba(0,0,0,0.05);
  min-height: calc(100vh - 200px);
  padding: 1px 30px 30px 30px;
`

const PageContainer = ({ children, ...otherProps }) => {
  return (
    <>
      <Menu />
      <Heading />
      <PageContainerStyled>
        <div style={{ maxWidth: 800 }} {...otherProps}>
          {children}
        </div>
      </PageContainerStyled>
      <Footer />
    </>
  )
}

export default PageContainer
